import { render, staticRenderFns } from "./QuickNavigation.vue?vue&type=template&id=7636cff5&scoped=true&"
import script from "./QuickNavigation.vue?vue&type=script&lang=js&"
export * from "./QuickNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636cff5",
  null
  
)

export default component.exports